import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import SEO from '../../Components/Common/SEO';

const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-karibu-100 flex flex-col items-center justify-center px-4 text-center">
            <SEO title="Page Not Found" canonicalPath="/404" noindex />
            <p className="font-display text-6xl font-bold text-highland-500">404</p>
            <h1 className="font-display text-2xl font-bold text-soil-900 mt-4">Page not found</h1>
            <p className="text-soil-600 mt-2 max-w-sm">
                The page you're looking for doesn't exist or hasn't been built yet.
            </p>
            <div className="flex items-center space-x-3 mt-6">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center px-4 py-2 border border-soil-100 rounded-lg text-soil-600 hover:bg-soil-50 transition-colors text-sm font-medium"
                >
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Go Back
                </button>
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center px-4 py-2 bg-highland-500 text-white rounded-lg hover:bg-highland-600 transition-colors text-sm font-medium"
                >
                    <Home className="h-4 w-4 mr-2" />
                    Home
                </button>
                <button
                    onClick={() => navigate('/listings')}
                    className="flex items-center px-4 py-2 bg-highland-500 text-white rounded-lg hover:bg-highland-600 transition-colors text-sm font-medium"
                >
                    <Search className="h-4 w-4 mr-2" />
                    Browse Listings
                </button>
            </div>
        </div>
    );
};

export default PageNotFound;
